import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    selectCustomer,
} from '../../redux/slices/customer-slice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Tabs } from '../../ui'
import { BackNavButton, RefreshNavButton } from '../../components/base/navigation-button';
import AppWrapper from '../../components/base/app-wrapper';
import PaymentsDataView from '../../components/details-view/payments-data';
import PaymentsDataFilter from '../../components/details-view/payments-data-filter';
import { fetchPaymentsData, resetAndFetchPayments, resetPaymentsList, selectPaymentsStore } from '../../redux/slices/payments-slice';
import { selectNotificationStore } from '../../redux/slices/notification-slice';


export default function PaymentsViewPage() {
    const paymentsStore = useAppSelector(selectPaymentsStore());
    const customer = useAppSelector(selectCustomer());
    const notification = useAppSelector(selectNotificationStore());
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [startDateRange, setStartDateRangeFilter] = React.useState('');
    const [stopDateRange, setStopDateRangeFilter] = React.useState('');
    const [paymentState, setPaymentStateFilter] = React.useState('');
    const [serviceProvider, setServiceProviderfilter] = React.useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        const serviceProvider = searchParams.get('msp');
        const paymentState = searchParams.get('state');
        const startDateRange = searchParams.get('start');
        const stopDateRange = searchParams.get('stop');

        setServiceProviderfilter(serviceProvider);
        setPaymentStateFilter(paymentState);
        setStopDateRangeFilter(stopDateRange);
        setStartDateRangeFilter(startDateRange);
    }, [searchParams]);

    const navigateToStartpage = () => {
        dispatch(resetPaymentsList());
        navigate('/');
    };

    useEffect(() => {
        if (paymentState && paymentsStore.list !== data) {
            dispatch(resetAndFetchPayments({
                paymentState,
                formDate: startDateRange,
                toDate: stopDateRange,
                serviceProvider: serviceProvider,
            }));
        }
    }, [paymentState])

    const reloadPage = () => {
        if (paymentState) {
            dispatch(resetAndFetchPayments({
                paymentState,
                formDate: startDateRange,
                toDate: stopDateRange,
                serviceProvider: serviceProvider,
            }));
        }
    }

    const loadMoreHandler = () => {
        if (paymentsStore.cursor && paymentState) {
            dispatch(fetchPaymentsData({
                paymentState,
                formDate: startDateRange,
                toDate: stopDateRange,
                serviceProvider: serviceProvider,
                cursor: paymentsStore.cursor,
            }));
        }
    }

    useEffect(() => {
        if (paymentsStore?.list) setData(paymentsStore.list);
    }, [paymentsStore?.list])

    return (
        <AppWrapper
            customer={customer}
            leftNavActions={
                <>
                    <BackNavButton onClickAction={navigateToStartpage} />
                    <RefreshNavButton onClickAction={reloadPage} />
                </>
            }
            loading={paymentsStore?.status == 'loading'}
            errorDialog={notification?.errorDialog}
        >
            <div className="detail-container">
                <Tabs selected='payment-details'>
                    <Tabs.Header testId='tabsHeaders'>
                        <Tabs.HeaderItem tabId={'payment-details'} icon="user" className="details-tab">
                            &nbsp;&nbsp;Details
                        </Tabs.HeaderItem>
                    </Tabs.Header >
                    <Tabs.Content>
                        <Tabs.ContentItem aria-labelledby={'details'} tabId={'payment-details'}>
                            <div className="customer-detail">
                                <PaymentsDataFilter
                                    initPaymentState={paymentState}
                                    initMSP={serviceProvider}
                                    initStartDate={startDateRange}
                                    initStopDate={stopDateRange}
                                />
                            </div>
                            <div className="customer-detail">
                                <PaymentsDataView
                                    data={data}
                                    coursor={paymentsStore?.cursor}
                                    loadMoreHandler={loadMoreHandler}
                                />
                            </div>
                        </Tabs.ContentItem>
                    </Tabs.Content >
                </Tabs >
            </div >
        </AppWrapper >
    );
}
